import React, { useState } from "react";
import { FaUsers } from "react-icons/fa";
import { MdOutlineSettings, MdOutlineDashboard } from "react-icons/md";
import { BsArrowLeftShort, BsCameraVideo } from "react-icons/bs";
import { DiNetbeans } from "react-icons/di";
import { FaTasks } from "react-icons/fa";
import { RiEdit2Fill } from "react-icons/ri";
import { IoBookOutline } from "react-icons/io5";
import { BsDatabase, BsFileEarmarkText } from "react-icons/bs";
import { NavLink } from "react-router-dom";
import logo from "../../assets/logo.png";
import { IoIosArrowUp } from "react-icons/io";
import { HiOutlineUserGroup } from "react-icons/hi2";
const Sidebar = () => {
  const [open, setOpen] = useState(true);
  const [subMenu, setSubMenu] = useState(false);

  const sideMenus = [
    {
      name: "Dashboard",
      link: "/",
      icon: MdOutlineDashboard,
    },
    {
      name: "Project Details",
      link: "/project_details",
      icon: BsFileEarmarkText,
    },
    { name: "Tasks", link: "/tasks", icon: FaTasks },
    { name: "Documentation", link: "/documentation", icon: IoBookOutline },
    {
      name: "Studio",
      link: "/studio",
      icon: DiNetbeans,
      margin: true,
      sub: [
        {
          name: "Storyboard",
          link: "/storyboard",
        },
        {
          name: "Database Models",
          link: "/database",
        },
        {
          name: "Application Architecture",
          link: "/application",
        },
        {
          name: "D2",
          link: "/d2",
        },
      ],
    },
    { name: "Form Builder", link: "/form_builder", icon: RiEdit2Fill },
    { name: "IDE", link: "/ide", icon: BsDatabase },
    { name: "Team Members", link: "/team_member", icon: FaUsers, margin: true },
    { name: "Team", link: "/team", icon: HiOutlineUserGroup },
    {
      name: "Video Conferencing",
      link: "/video_conferencing",
      icon: BsCameraVideo,
    },
    {
      name: "Settings",
      link: "/settings",
      icon: MdOutlineSettings,
      margin: true,
    },
  ];
  return (
    <section className="flex gap-6">
      <div
        className={`bg-[#161b22] min-h-screen ${
          open ? "w-72" : "w-16"
        } duration-500 text-gray-100 relative`}>
        <BsArrowLeftShort
          className={`bg-[#161B22] text-white rounded-md text-3xl cursor-pointer absolute -right-4 top-4 ${
            !open && "rotate-180"
          }`}
          style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px" }}
          onClick={() => {
            setOpen(!open);
            setSubMenu(false);
          }}
        />

        <div className="inline-flex mt-4 px-4">
          <img
            src={logo}
            alt="logo"
            width={40}
            className="cursor-pointer block float-left mr-2"
          />
          <p
            className={`origin-left font-semibold text-xl duration-300 ml-1 ${
              !open && "scale-0"
            }`}>
            {" "}
            DE<span className="text-[#1068BF]">VT</span>ools
          </p>
        </div>

        <div className="mt-4 flex flex-col gap-1.5 relative">
          {sideMenus?.map((menu, i) => {
            return (
              <NavLink
                to={menu?.link}
                key={i}
                className={` ${menu?.margin && "mt-5"} group flex ${
                  menu?.sub ? "flex flex-col justify-start" : ""
                } justify-between text-sm gap-3.5 font-medium p-2 hover:bg-gray-800 rounded-none new `}>
                {menu?.sub ? (
                  <div
                    className="flex justify-between items-center"
                    onClick={(e) => {
                      setSubMenu(!subMenu);
                    }}>
                    <div className="flex items-center text-sm gap-3.5 px-4">
                      <div>
                        {React.createElement(menu?.icon, { size: "20" })}
                      </div>
                      <h2
                        style={{
                          transitionDelay: `${i + 3}00ms`,
                        }}
                        className={`whitespace-pre duration-500 ${
                          !open && "opacity-0 translate-x-28 overflow-hidden"
                        }`}>
                        {menu?.name}
                      </h2>
                    </div>
                    <IoIosArrowUp className={`${subMenu && "rotate-180"}`} />
                  </div>
                ) : (
                  <div className="flex justify-between items-center">
                    <div className="flex items-center text-sm gap-3.5 px-4">
                      <div>
                        {React.createElement(menu?.icon, { size: "20" })}
                      </div>
                      <h2
                        style={{
                          transitionDelay: `${i + 3}00ms`,
                        }}
                        className={`whitespace-pre duration-500 ${
                          !open && "opacity-0 translate-x-28 overflow-hidden"
                        }`}>
                        {menu?.name}
                      </h2>
                    </div>
                  </div>
                )}

                <h2
                  className={`${
                    open && "hidden"
                  } absolute left-48 bg-[#424242] text-white font-semibold whitespace-pre  rounded-sm drop-shadow-lg px-0 py-0 w-0 overflow-hidden group-hover:px-2 group-hover:py-1 group-hover:left-20 group-hover:duration-300 group-hover:w-fit`}>
                  {menu?.name}
                </h2>
                {subMenu &&
                  menu?.sub &&
                  menu?.sub.map((e, j) => (
                    <NavLink
                      key={j}
                      to={e?.link}
                      className={`pl-12 py-2 flex items-center text-sm gap-1`}>
                      <h2
                        style={{
                          transitionDelay: `${j + 3}00ms`,
                        }}
                        className={`whitespace-pre duration-500 ${
                          !open && "opacity-0 translate-x-28 overflow-hidden"
                        }`}>
                        {e?.name}
                      </h2>
                    </NavLink>
                  ))}
              </NavLink>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Sidebar;
